/**
 * @fileoverview Device identity configuration.
 * @description Names the storage key used to persist the device ID (survives across sessions, one
 * per browser/device), which login, MFA and password reset send to the backend in their request
 * bodies.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

export const deviceConfig = {
  deviceIdStorageKey: 'brownbox.device.id',
}
